import React from 'react';
import { observer } from 'mobx-react-lite';
import { StarterKitTab } from '../../model/StarterKitTab';
import { KitGrid } from '../card/KitGrid';
import { useTranslation } from 'react-i18next';

interface OtherKitTabProps {
  tab: StarterKitTab;
}

export const OtherKitTab = observer(({ tab }: OtherKitTabProps) => {
  const { t } = useTranslation();
  return (
    <div className='other-kit-tab'>
      <div>
        <p>{t('SelectSpecialtyKitHelpPart1')}</p>
        <p>{t('SelectSpecialtyKitHelpPart2')}</p>
      </div>

      <KitGrid kits={tab.productKits} />
    </div>
  );
});
